import type { IconProps } from '.';

/**
 * Minus Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const MinusIcon = ({ className }: IconProps) => (
  <svg
    role="presentation"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <rect x="4" y="11.5" width="16" height="1" fill="white" />
  </svg>
);

export default MinusIcon;
